import { useState, useEffect } from 'react';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import AIAnalystPanel from '@/components/ai/AIAnalystPanel';
import { ArrowUpCircle, ChevronDown } from 'lucide-react';
import api from '@/lib/api';
import { useProject } from '@/contexts/ProjectContext';
import RollUpDashboard from '@/components/rollup/RollUpDashboard';
import MacroDetailPanel from '@/components/rollup/MacroDetailPanel';

export default function ScheduleRollUp() {
  const { selectedProject, projectId: ctxProjectId } = useProject();
  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState('');
  const [selectedMacro, setSelectedMacro] = useState(null);

  useEffect(() => {
    const params = selectedProject?.project_id
      ? `?portfolio_project_id=${selectedProject.project_id}`
      : '';
    api.get(`/scheduling/projects${params}`).then(r => {
      const list = r.data || [];
      setProjects(list);
      if (list.length > 0) setSelectedProjectId(list[0].id);
      else setSelectedProjectId('');
    }).catch(() => {});
  }, [selectedProject]);

  return (
    <DashboardLayout>
      {ctxProjectId && <AIAnalystPanel projectId={ctxProjectId} moduleKey="MACRO_SCHEDULE" defaultOpen={true} compact={true} />}

      <div className="space-y-4 p-4 md:p-6" data-testid="schedule-rollup-page">
        {/* Header */}
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-3">
            <div className="p-2.5 rounded-xl" style={{ background: '#143A6B20', border: '1px solid #143A6B40' }}>
              <ArrowUpCircle className="w-6 h-6" style={{ color: '#143A6B' }} />
            </div>
            <div>
              <h1 className="text-xl font-bold" style={{ color: 'var(--text-primary)' }}>Schedule Roll-Up Engine</h1>
              <p className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>
                Aggregate micro schedule progress into macro activities via weighted linkages
              </p>
            </div>
          </div>
          {/* Project Selector */}
          <div className="relative" data-testid="rollup-project-selector">
            <select
              value={selectedProjectId}
              onChange={e => { setSelectedProjectId(e.target.value); setSelectedMacro(null); }}
              className="appearance-none pl-3 pr-8 py-2 rounded-lg text-sm font-medium cursor-pointer"
              style={{ backgroundColor: 'var(--card-bg)', border: '1px solid var(--border-color)', color: 'var(--text-primary)' }}>
              {projects.map(p => (
                <option key={p.id} value={p.id}>{p.name}</option>
              ))}
            </select>
            <ChevronDown className="w-3.5 h-3.5 absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none" style={{ color: 'var(--text-muted)' }} />
          </div>
        </div>

        {/* Dashboard */}
        {selectedProjectId && (
          <RollUpDashboard
            projectId={selectedProjectId}
            onSelectMacro={setSelectedMacro}
          />
        )}

        {/* Macro Detail Panel */}
        {selectedMacro && (
          <MacroDetailPanel
            projectId={selectedProjectId}
            macro={selectedMacro}
            onClose={() => setSelectedMacro(null)}
          />
        )}
      </div>
    </DashboardLayout>
  );
}
